/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class TopSniper {
    public static inicializar() {
      let topSniper = new App.TopSniper();
      topSniper.inicializarEventos();
    }
  }
}

namespace App {
  export class TopSniper {
    private idExtensao: string = "pnenhoomfmddepcbmmkpkbdoplmjohge";
    public static readonly USUARIO_TOP_SNIPER_DIEGO = 3;
    public static readonly USUARIO_TOP_SNIPER_FERNANDO = 7;
    public static readonly USUARIO_TOP_SNIPER_MARCELO = 841;
    public static readonly USUARIO_TOP_SNIPER_PC = 28923;

    private userId: number = null;
    private static readonly USUARIOS_PERMITIDOS: any = [TopSniper.USUARIO_TOP_SNIPER_DIEGO, TopSniper.USUARIO_TOP_SNIPER_FERNANDO, TopSniper.USUARIO_TOP_SNIPER_MARCELO, TopSniper.USUARIO_TOP_SNIPER_PC];
    private urlUpdateFiltro: string = null;
    private idPlataforma: any = 1;
    public valorInvestido: number;
    public snipou: number;
    public disputaPerdida: number;
    public valorFutbin: number;
    public keyStorageCachePrecoFutbin: string = "key_storage_cache_preco_futbin";
    public minutosCachePrecoFutbin: number = 60; //1 hora
    public static objDataTableTopSniper: any = null;
    public static objPlayers: IPlayerJson = null;
    public elDataTableTopSniper: any = $("#dataTableTopSnipers");
    public static objJogadorDefault: any = { "f": "Não", "id": 0, "l": "Identificado", "r": 0 };
    private topSniperAdminFernando: TopSniperFernando = null
    private topSniperAdminDiego: TopSniperDiego = null
    private topSniperPc: TopSniperPc = null
    private topSniperMarcelo: TopSniperMarcelo = null

    public async inicializarEventos() {
      this.userId = $('#section-components').data('idUser')
      this.urlUpdateFiltro = $('#section-components').data('urlUpdateFiltro')
      App.Util.exibirLoadingTableContas()

      var idExtensao: any = await App.Util.aguardarValorElemento('#idExtensao');
      if (idExtensao) {
        this.idExtensao = idExtensao
      }
      let params = new URLSearchParams(window.location.href)
      if (params.get('extension_id')) {
        this.idExtensao = params.get('extension_id')
      }

      if (params.get('id_plataforma')) {
        this.idPlataforma = params.get('id_plataforma')
      }

      this.topSniperAdminFernando = new App.TopSniperFernando(this.urlUpdateFiltro);
      this.topSniperAdminDiego = new App.TopSniperDiego(this.urlUpdateFiltro);
      this.topSniperPc = new App.TopSniperPc(this.urlUpdateFiltro);
      this.topSniperMarcelo = new App.TopSniperMarcelo(this.urlUpdateFiltro);

      console.log("URL", window.location.href, ` | ID: ${this.userId}`)
      let algumRedirecionamentoNovaUrl = await this.processarRegrasDeUrl(this.userId, window.location.href)
      if (algumRedirecionamentoNovaUrl) {
        console.log("REDIRECIONAMENTO PARA NOVA URL", algumRedirecionamentoNovaUrl)
        window.location.href = algumRedirecionamentoNovaUrl
        return
      }


      this.getPlayers(() => {
        this.inicializarDataTable();
      });
    }

    private getPlayers(metodoCallback: any) {
      const hoje = new Date();
      const parametroCache = `${hoje.getFullYear()}-${hoje.getMonth() + 1}-${hoje.getDate()}`; // Gera o parâmetro baseado na data atual
      $.getJSON("/players.json", { _: parametroCache }, (data) => {
        TopSniper.objPlayers = data.Players;
        metodoCallback();
      });
    }

    private async sleep(milisegundos: number) {
      return new Promise((resolve: any) => setTimeout(resolve, milisegundos));
    }

    private async inicializarDataTable() {
      var urlLinkFutbin = "https://www.futbin.com/players?page=1&eUnt=1&order=desc&sort=ps_price&pos_type=all"
      var dataTopSnipers = $('#cardDadosSnipers').data('dadosSnipers');
      var dataRaridades = $('#cardDadosSnipers').data('raridades');
      // console.log("inicializarDataTable", dataRaridades, dataTopSnipers)
      try {
        // console.log('dataTopSnipers', dataTopSnipers);
        dataTopSnipers = dataTopSnipers.filter((ele: any) => {
          return ele.resource_id != 50570091
            && ele.resource_id != 84124515
            && ele.resource_id != 83892315
            && ele.resource_id != 83940130
            && ele.resource_id != 50557941
            && ele.resource_id != 67265217
            && ele.resource_id != 84136970
            && ele.resource_id != 67336188
            && ele.resource_id != 67347246
            && ele.resource_id != 67336127
            && ele.resource_id != 67335157
            && ele.resource_id != 67335157
            && ele.resource_id != 67110065;
        });
      } catch (error) {
        console.log('FERNANDO ENSINOU CAGADA:: ', error);
      }


      var dataTopSnipersAnterior: any = Util.getDadosTopSniperAnterior(dataTopSnipers)
      //console.log("dataTopSnipersAnterior", dataTopSnipersAnterior)

      for await (const [index, dataSniper] of dataTopSnipers.entries()) {
        try {
          let dados: IFutbin = await this.getPrecoFutbin(dataSniper.resource_id, this.idPlataforma);

          if (!dados || !dados.hasOwnProperty('preco')) {
            var response = await fetch(`${Util.URL_FUTBIN_ORG_API}fetchPriceInformation?playerresource=${dataSniper.resource_id}&platform=${this.idPlataforma == 3 ? 'PC' : 'PS'}`, { method: "GET", headers: { Accept: "application/json", 'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/130.0.0.0 Safari/537.36' } });
            var infoPrice: { LCPrice: number, LCPrice2: number, LCPrice3: number, updatedon: number, MinPrice: number, MaxPrice: number } = await response.json();
            dados = { preco: infoPrice.LCPrice ? infoPrice.LCPrice : infoPrice.MaxPrice };
          }

          var player = App.Util.getItemArrayById(TopSniper.objPlayers, dataSniper.asset_id, TopSniper.objJogadorDefault);
          var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
          dataTopSnipers[index].nome = nomeJogador;
          dataTopSnipers[index].preco = dados.preco;
          dataTopSnipers[index].preco_total = dados.preco * dataSniper.total
          dataTopSnipers[index].quantidade_mais = dataTopSnipersAnterior && dataTopSnipersAnterior[index] && dataSniper.total > dataTopSnipersAnterior[index].total ? (dataSniper.total - dataTopSnipersAnterior[index].total) : 0;
          let taxaEA = dataSniper.preco_total * 0.05;
          dataTopSnipers[index].lucro = dataTopSnipers[index].preco_total - taxaEA - dataSniper.valor_total_gasto;
          dataTopSnipers[index].raridade = dataRaridades.find((raridade: any) => raridade.id == dataSniper.rareflag)
          let newUrlLinkFutbin = `${urlLinkFutbin}&club=${dataSniper.team_id}&nation=${dataSniper.nation_id}`
          dataTopSnipers[index].urlLinkFutbin = dataSniper.asset_id != dataSniper.resource_id && dataSniper.rareflag >= 3 ? newUrlLinkFutbin + `&version=all_specials` : newUrlLinkFutbin
          dataTopSnipers[index].lucro_unitario = Util.getLucroCarta(dataTopSnipers[index].valor, dataTopSnipers[index].preco)

          this.definicaoTopCartasParaUsuarioLogado(this.userId, dataTopSnipers[index])

        } catch (error) {
          console.log("ERROR AO TRATAR CARTA:", error, dataSniper)
          continue
        }
      }

      this.preparacaoTopCartasParaUsuarioLogado(this.userId)

      this.initializarTabelaTopSniper(dataTopSnipers)
      App.Util.ocultarLoadingTableContas()
      this.loopBuscasParaAtualizacaoDeFiltros()
    }

    public initializarTabelaTopSniper(dataTopSnipers: any) {
      TopSniper.objDataTableTopSniper = this.elDataTableTopSniper.DataTable({
        language: {
          url: "/datatable-pt-br.json",
        },
        pageLength: 1000,
        bLengthChange: false,
        bInfo: false,
        data: dataTopSnipers,
        bAutoWidth: false,
        rowId: 'id',
        dom: 'Bfrtip',
        select: true,
        buttons: [],
        order: [[3, 'desc'], [4, 'desc']],
        columnDefs: [
          {
            targets: 0,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              var qualidade = obj.rating < 65 ? '_1' : (obj.rating < 75 ? '_2' : '_3');
              var ehEspecialRaro = obj.rareflag > 3;
              qualidade = ehEspecialRaro ? '_0' : qualidade;
              var bgCard = "e_" + obj.rareflag + qualidade + ".png";
              var urlFutbin = "";
              var divImg = `<div class="playercard-picture"><img src="https://cdn.futnext.com/player/${obj.asset_id}.png" /></div>`
              var nomeraridade = obj.raridade && obj.raridade.nome ? `<span class="text-primary text-center font-weight-bold text-uppercase" style="font-size: 12px;">${obj.rating} - ${obj.raridade.nome}</span>` : ' - '

              data = '<div data-toggle="tooltip" data-placement="top" title="' + obj.nome + '" class="playercard fut21 playercard-s" style="background-image: url(' + "'https://cdn.futnext.com/rarity/" + bgCard + "'" + ');">' +
                '<p class="playercard-rating" style="color: #16181c;padding: 15px;margin-top:-20px;">' + obj.rating + '</p>\n\
                              <div class="playercard-position">' + (obj.hasOwnProperty("preferredPositionNameTraduzido") && obj.preferredPositionNameTraduzido ? obj.preferredPositionNameTraduzido : '') + '</div>\n\
                              <div class="playercard-nation" style="margin-top:-13px;"><img src="https://cdn.futnext.com/nation/'+ obj.nation_id + '.png" alt=""></div>\n\
                              <div class="playercard-club"><img src="https://cdn.futnext.com/club/' + obj.team_id + '.png" alt=""></div>\n\
                              <div class="playercard-name" style="background-color: #000000;color: #ffffff;"><span class="">' + obj.nome + '</span></div>\n\
                              '+ divImg + '\n\
                              <div class="playercard-line playercard-line1"></div><div class="playercard-line playercard-line2">\n\
                              </div><div class="playercard-line playercard-line3"></div>\n\
                              <div class="playercard-line playercard-line4"></div>\n\
                              <div class="playercard-line playercard-line5"></div>'+ nomeraridade + '</div>';
              return data;
            }
          },
          {
            targets: 1,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return `<span>${obj.total} ${obj.quantidade_mais ? `<span style="font-size: 14px;background-color: #71bf62;font-weight: 700;border-radius: 8px;padding: 2px;color: #ffffff;position: relative;top: -9px;">+${obj.quantidade_mais}</span>` : ''}</span>`;
            }
          },
          {
            targets: 2,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return `<span title="${obj.valor_all}"><i class="ni ni-money-coins mr-2" style="color: #e3a800" aria-hidden="true"></i>${obj.valor}</span><br />
              <span title="${obj.valor_all}"><img alt="sistema-futsniperweb" class="mr-1" src="/img/icons/futbin.png" style="width: 20px;" />${obj.preco}</span>`
            }
          },
          {
            targets: 3,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return `<span><i class="fas fa-arrow-up text-success mr-2" aria-hidden="true"></i>${obj.lucro}</span>`;
            }
          },
          {
            targets: 4,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return `<span><i class="fas fa-arrow-down text-danger mr-2" aria-hidden="true"></i>${obj.valor_total_gasto}</span><br /><span><i class="fas fa-arrow-up text-success mr-2" aria-hidden="true"></i>${obj.preco_total}</span>`;
            }
          },
          {
            targets: 5,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return obj.created_at;
            }
          },
          {
            targets: 6,
            visible: true,
            render: function (data: any, tipo: any, obj: any, meta: any) {
              return `<a href="${obj.urlLinkFutbin}" target="_blank"><i class="fa-solid fa-link mr-2"></i></a><i class="fas fa-filter mr-2 ml-1" title="${obj.ids_filtros}"></i>`
            }
          },
        ],
      });
    }

    private loopBuscasParaAtualizacaoDeFiltros() {
      if (TopSniper.USUARIOS_PERMITIDOS.includes(this.userId)) {
        setTimeout(() => {
          console.log("##### TIMEOUT...", Util.getCounterValue('contadorBuscasTopSniper'), new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString(), ' #####')
          if (Util.getCounterValue('contadorBuscasTopSniper') == 0) {
            console.log("PROCESSO INICIAL...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
          }
          if (Util.getCounterValue('contadorBuscasTopSniper') >= 5) {
            console.log("INICIAR NOVO PROCESSO...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
            Util.resetCounter('contadorBuscasTopSniper')
            this.recarregar(this.userId)
            return
          }
          if (Util.getCounterValue('contadorBuscasTopSniper') > 0) {
            console.log("REPETIR PROCESSO...", new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString())
          }
          $('#section-components > div > div > div > div > div > div > div.card-body > form > div > div.col-md-12.pt-1.pull-right > div > button').click();
          Util.incrementCounter('contadorBuscasTopSniper')
        }, this.getrecarregamentoTopSniperByUsuarioLogado(this.userId));
      }
    }

    private getrecarregamentoTopSniperByUsuarioLogado(userId: number) {
      switch (this.userId) {
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          return 120000;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          return 120000;
        default:
          return 120000;
      }
    }

    private definicaoTopCartasParaUsuarioLogado(userId: number, dataTopSniper: ICartaTopSniper) {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          this.topSniperPc.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          this.topSniperMarcelo.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          this.topSniperAdminDiego.condicaoTopCartasImportantes(dataTopSniper);
          break;
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          this.topSniperAdminFernando.condicaoTopCartasImportantes(dataTopSniper);
          break;
      }
    }

    private preparacaoTopCartasParaUsuarioLogado(userId: number) {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          this.topSniperPc.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          this.topSniperMarcelo.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          this.topSniperAdminDiego.prepararTopCartas()
          break;
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          this.topSniperAdminFernando.prepararTopCartas()
          break;
      }
    }

    private addCachePrecoFutbin(itemCache: IStoragePrecoFutbin) {
      let objStoragePrecoFutbin: IStoragePrecoFutbin[] = App.Util.getArrayStorage(this.keyStorageCachePrecoFutbin) || [];
      if (objStoragePrecoFutbin && objStoragePrecoFutbin.length) {
        if (App.Util.arrayExistByResourceId(objStoragePrecoFutbin, itemCache.resourceId)) {
          let index = App.Util.getIndiceArrayByResourceId(objStoragePrecoFutbin, itemCache.resourceId);
          objStoragePrecoFutbin[index] = itemCache;
        } else {
          objStoragePrecoFutbin.push(itemCache);
        }
      } else {
        objStoragePrecoFutbin.push(itemCache);
      }

      App.Util.setArrayStorage(this.keyStorageCachePrecoFutbin, objStoragePrecoFutbin);
    }

    private getPrecoFutbin(resource_id: number, id_plataforma: number): Promise<IFutbin> {
      return new Promise(async (resolve: any, reject: any) => {

        try {
          let objStoragePrecoFutbin: IStoragePrecoFutbin[] = App.Util.getArrayStorage(this.keyStorageCachePrecoFutbin) || [];
          let item: IStoragePrecoFutbin = objStoragePrecoFutbin && objStoragePrecoFutbin.length ? App.Util.getItemArraySeExistResourceId(objStoragePrecoFutbin, resource_id) : null;
          let itemTemCacheValido: boolean = item && item.preco && item.update_at && (App.Util.getMinutosPassadosPartirDaDataInicial(new Date(item.update_at), new Date()) < this.minutosCachePrecoFutbin);

          if (itemTemCacheValido) {
            resolve(item.preco);
          } else {
            await this.sleep(App.Util.getRandomInt(50, 1000));
            chrome.runtime.sendMessage(this.idExtensao, { evento: "bpftb", idJogador: resource_id, platform: id_plataforma == 3 ? 'pc' : 'ps' },
              (resultado: { response: IFutbin, status: boolean }) => {
                if (resultado && resultado.status) {
                  this.addCachePrecoFutbin({ update_at: new Date().toISOString(), resourceId: resource_id, preco: resultado.response });
                  resolve(resultado.response);
                } else {
                  resolve(null);
                }
              });
          }
        } catch (error) {
          console.log('ERROR: ', error);
          resolve(null);
        }
      });
    }

    private async processarRegrasDeUrl(userId: number, urlAtual: string): Promise<string> {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          return await this.topSniperPc.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          return await this.topSniperMarcelo.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          return await this.topSniperAdminDiego.validarRegrasUrlCarregada(urlAtual)
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          return await this.topSniperAdminFernando.validarRegrasUrlCarregada(urlAtual)
      }
    }

    private recarregar(userId: number) {
      switch (userId) {
        case TopSniper.USUARIO_TOP_SNIPER_PC:
          this.topSniperPc.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_MARCELO:
          this.topSniperMarcelo.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_DIEGO:
          this.topSniperAdminDiego.iniciarRecarregamento()
          break
        case TopSniper.USUARIO_TOP_SNIPER_FERNANDO:
          this.topSniperAdminFernando.iniciarRecarregamento()
          break
      }
    }
  }
}
